// extracted by mini-css-extract-plugin
module.exports = {"table":"PermissionsTable_table_2STCI"};